// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_attendence,
  add_attendence,
  update_attendence,
  delete_attendence,
  get_attendence_register,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  attendences: [],
  attendencesregister:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    student: "",
    date: getTodayDate()||"",
    section: "",
    school_class: "",
    status: "",
  },
  filterData: {
    date: getTodayDate()||"",
    section: "",
    school_class: "",
    student: ""
  },
};

// Async Thunks for API Calls
export const fetchattendenceregister = createAsyncThunk(
  "attendence/fetchattendenceregister",
  async (
    {  school_id,
      month,
      year,
      class_id,
      section_id,
      student_id,
      token,
      signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_attendence_register(
        school_id,
        month,
        year,
        class_id,
        section_id,
        student_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchattendence = createAsyncThunk(
  "attendence/fetchattendence",
  async (
    { page, page_size, school_id,date,
        class_id,
        section_id,student_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_attendence(
        page,
        page_size,
        school_id,
        date,
        class_id,
        section_id,
        student_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createattendence = createAsyncThunk(
  "attendence/createattendence",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_attendence(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateattendence = createAsyncThunk(
  "attendence/updateattendence",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_attendence(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteattendence = createAsyncThunk(
  "attendence/deleteattendence",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_attendence({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const attendenceSlice = createSlice({
  name: "attendences",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        student,
        date,
        section,
        school_class,
        status,
      } = action.payload;
      state.formData = {
        id,
        student,
        date,
        section,
        school_class,
        status,
      };
    },
    resetFormData(state) {
      state.formData = {
        student: "",
    date: getTodayDate()||"",
    section: "",
    school_class: "",
    status: "",
      };
    },
    setattendence(state, action) {
      state.attendences = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch register Classes
      .addCase(fetchattendenceregister.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchattendenceregister.fulfilled, (state, action) => {
        state.loading = false;
        state.attendencesregister = action.payload;
      })
      .addCase(fetchattendenceregister.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.attendencesregister = [];

      })
      // Fetch Classes
      .addCase(fetchattendence.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchattendence.fulfilled, (state, action) => {
        state.loading = false;
        state.attendences = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchattendence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.attendences = [];

      })

      // Add Class
      .addCase(createattendence.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createattendence.fulfilled, (state, action) => {
        state.addLoading = false;
        state.attendences = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createattendence.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateattendence.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateattendence.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateattendence.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteattendence.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteattendence.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteattendence.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setattendence,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,
} = attendenceSlice.actions;
export default attendenceSlice.reducer;
